// LLM generated - Model Claude 4 Sonnet
import { IconDeviceDesktopOff } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import { EmptyState } from '../../../EmptyState';

function ChatUnavailableOnWeb() {
  const { t } = useTranslation('chat');

  return (
    <EmptyState
      icon={<IconDeviceDesktopOff size={40} />}
      title={t('emptyStates.chatUnavailableOnWeb.title')}
      description={t('emptyStates.chatUnavailableOnWeb.description')}
      size="md"
      c="gray2.3"
    />
  );
}

export default ChatUnavailableOnWeb;
